// extracted by mini-css-extract-plugin
export default {"root":"styles_root__ZPqbt","item":"styles_item__gcLTD","buttons_container":"styles_buttons_container__R-A3c"};